export enum ZipYiElement {
  GiftCardSearchInput = 'gc-search-input',
  GiftCardDenominationSelect = 'gc-denomination-select',
  GiftCardCustomDenominationInput = 'gc-custom-denomination-input',
  GiftingRecipientEmail = 'gc-gifting-recipient-email-input',
  GiftingRecipientEmailConfirm = 'gc-gifting-recipient-email-confirm-input',
  GiftingRecipientName = 'gc-gifting-recipient-name-input',
  GiftingNote = 'gc-gifting-note-text-area',
  GiftingScheduleToggle = 'gc-scheduled-gifting-toggle',
  GiftingScheduledDate = 'gc-scheduled-gifting-date-input',
  GiftingConfirmBtn = 'gc-gifting-confirm-btn',
  BuyForFriendButton = 'gc-buy-for-friend-btn',
  BuyForMyselfButton = 'gc-buy-for-myself-btn',
}
